import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Templates from "@/pages/Templates";
import BrandKit from "@/pages/BrandKit";
import Marketing from "@/pages/Marketing";
import ImageStudio from "@/pages/ImageStudio";
import ImageRecolor from "@/pages/ImageRecolor";
import Editor from "@/pages/Editor";
import Manuals from "@/pages/Manuals";
import ManualEditor from "@/pages/ManualEditor";
import InteractiveManualPage from "@/pages/InteractiveManualPage";
import TechnicalDrawing from "@/pages/TechnicalDrawing";
import EmbedManual from "@/pages/EmbedManual";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="/embed/manual/:id" element={<EmbedManual />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
            <Route path="/brand-kit" element={<ProtectedRoute><BrandKit /></ProtectedRoute>} />
            <Route path="/marketing" element={<ProtectedRoute><Marketing /></ProtectedRoute>} />
            <Route path="/ai-images" element={<ProtectedRoute><ImageStudio /></ProtectedRoute>} />
            <Route path="/recolor" element={<ProtectedRoute><ImageRecolor /></ProtectedRoute>} />
            <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
            <Route path="/manuals" element={<ProtectedRoute><Manuals /></ProtectedRoute>} />
            <Route path="/manuals/:id" element={<ProtectedRoute><ManualEditor /></ProtectedRoute>} />
            <Route path="/manuals/:id/interactive" element={<ProtectedRoute><InteractiveManualPage /></ProtectedRoute>} />
            <Route path="/technical-drawing" element={<ProtectedRoute><TechnicalDrawing /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
